import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CereriService } from '../../../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-view-matricole',
    templateUrl: './view-matricole.component.html',
    styleUrls: ['./view-matricole.component.scss']
})
export class ViewMatricoleComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    isLoading: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ViewMatricoleComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
    ) { }

    closeDialog(): void {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const id = this.data.id_cerere
        const { matricole, allMatricole, id_cerere, ...newData } = this.data;
        const data = newData;

        this.cereriService
            .generateCF(id, data)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.warningSwal(this.errorTitle, err.error.errors.message, this.errorIcon);
                },
            });
    }
}
